export default __webpack_public_path__ + "static/media/a.9ebc6be6.jpg";